import { IIssueBoardApi } from "@mcapps/shared";
import { IIssueApi } from "@schemas/issueSchema";
import React, { useState } from "react";
import { FailedAlert } from "../../../../../components";
import { ConnectedIssues } from "../../../../../components/ConnectedIssues/ConnectedIssues";
import CreateItemWithBoardSelectorModal from "../../../../../components/CreateItemWithBoardSelectorModal/CreateItemWithBoardSelectorModal";
import { useAppSelector } from "../../../../../hooks";
import { MCApplicationsUrlEnum } from "../../../../../mc-shared/sharedConstants";
import ConnectExistingIssueToItemModalWrapper from "../../../../ConnectExistingIssueToItemModalWrapper";
import { useGetProjectByProjectIdIssueboardQuery } from "../../../../../../openapi";
import { useConnectIssueOrTaskFromOtherBoardsToIssueMutation, useCreateIssueMutation } from "../../issueRTK";

const ConnectedTasksAndIssuesMiniTable: React.FC<{
  issue: IIssueApi;
  issueId: string;
  projectId: string;
  issueBoardId: string;
  fullWidth: boolean;
  issueBoard?: IIssueBoardApi;
}> = ({ issue, issueId, projectId, issueBoardId, issueBoard }) => {
  const [newIssueModalOpen, setNewIssueModalOpen] = useState<boolean>(false);
  const [connectExistingModalOpen, setConnectExistingModalOpen] = useState<boolean>(false);

  const titleLabel = `Koblede fra andre registre`;

  const [connectIssueOrTask, { isLoading, isSuccess, error: connectIssueOrTaskError }] =
    useConnectIssueOrTaskFromOtherBoardsToIssueMutation();

  const [addNewIssue, { isLoading: addNewIssueIsLoading, isSuccess: addNewIssueIsSuccess, error: addNewIssueError }] =
    useCreateIssueMutation();

  const { data: issueBoards = [], error: boardFetchError } = useGetProjectByProjectIdIssueboardQuery({
    projectId: projectId,
  });

  const isError = connectIssueOrTaskError || addNewIssueError || boardFetchError;

  const apps = useAppSelector((state) => state.globalReducer.apps);

  const onConnect = (issueOrTaskId: string) => {
    connectIssueOrTask({
      projectId: projectId,
      issueId: issueId,
      issueOrTaskId: issueOrTaskId,
      connectOrDisconnect: "CONNECT",
    });
    setConnectExistingModalOpen(false);
  };

  const onCreateIssue = async (boardId: string) => {
    const createdIssue = await addNewIssue({
      projectId: projectId,
      issueBoardId: boardId,
      issueTitle: "",
      taskOrIssue: "ISSUE",
    });
    await connectIssueOrTask({
      projectId: projectId,
      issueId: issueId,
      issueOrTaskId: createdIssue?.data?._id,
      connectOrDisconnect: "CONNECT",
    });
    setNewIssueModalOpen(false);
  };

  return (
    <>
      {isError && <FailedAlert />}
      <div className="bg-white">
        <ConnectExistingIssueToItemModalWrapper
          opened={connectExistingModalOpen}
          onConnected={(boardId, issueOrTaskId) => onConnect(issueOrTaskId)}
          projectId={projectId}
          closeModal={() => setConnectExistingModalOpen(false)}
          blockedIssueIds={issue?.connectedTasksAndIssuesFromOtherBoards?.map((issue) => issue._id) || []}
        />
        <CreateItemWithBoardSelectorModal
          boards={(issueBoards || []).map((board) => {
            return {
              project: board.project,
              name: board.name,
              _id: board._id,
              status: board.status,
            };
          })}
          onCreate={onCreateIssue}
          modalTitle="Koble sak til sjekklistepunkt"
          opened={newIssueModalOpen}
          onClose={() => setNewIssueModalOpen(false)}
          currentApp={MCApplicationsUrlEnum.ISSUE}
          apps={apps}
          projectId={projectId}
          createButtonText="Opprett sak"
        />
        <ConnectedIssues
          issues={issue.connectedTasksAndIssuesFromOtherBoards as IIssueApi[]}
          onDisconnectIssue={(issueOrTaskId) =>
            connectIssueOrTask({
              projectId: projectId,
              issueId: issueId,
              issueOrTaskId: issueOrTaskId,
              connectOrDisconnect: "DISCONNECT",
            })
          }
          onConnectExistingIssue={() => setConnectExistingModalOpen(true)}
          onCreateNewIssue={() => setNewIssueModalOpen(true)}
          isPrintMode={false}
          disableCellEdit={true}
          titleLabel={titleLabel}
          hideRegisterColumn={false}
          projectId={projectId}
          hideAssignedTo={true}
        />
      </div>
    </>
  );
};

export default ConnectedTasksAndIssuesMiniTable;
